import {EventContainerListDispositionSidePanel} from "~/components/eventContainerDetails/eventContainerListDispositionSidePanel";
import type {EventContainerTemplate} from "~/domainModels/workspaceModules/eventContainersModule";
import type {OttopilotDispositionConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerDispositionConfig";
import type {OttopilotTriggerConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerTriggerConfig";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {EventWithEventContainer} from "~/utilities/apis/api";

/** @deprecated Prefer {@link EventContainerListDispositionSidePanel}; kept for existing imports. */
export function EventContainerListDispositionModal(props: {
    onClose: () => void;
    event: EventWithEventContainer;
    eventContainerTemplate: EventContainerTemplate;
    triggerConfiguration: OttopilotTriggerConfig;
    dispositionConfiguration: OttopilotDispositionConfig;
    dispositionUiLevels?: number;
    /** When set, overrides `eventContainerTemplate.dispositions` (e.g. Dulux flat slug hierarchy). */
    dispositions?: Array<{id: Uuid; displayName: string}>;
    getLeadDisplayName: (event: EventWithEventContainer) => string;
    queryKeyPrefix: Array<string | null>;
    /** Runs after a successful save, before ottopilot data-viewer invalidation (e.g. Amaron kanban dataset). */
    invalidateQueriesBeforeDataViewer?: () => Promise<void>;
    /** Runs after the Event Container disposition is persisted; use for optimistic kanban cache updates. */
    onDispositionSaved?: (args: {eventContainerId: Uuid; dispositionId: Uuid}) => void | Promise<void>;
    /** When false, skips the default data-viewer invalidation (e.g. optimistic kanban already updated). */
    refetchDataViewerAfterSave?: boolean;
    onRefreshStateChange?: (isRefreshing: boolean) => void;
}) {
    return <EventContainerListDispositionSidePanel {...props} />;
}
